import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UtilsService } from "./utils";
import { StorageService } from "./storage.service";
import { NetworkService } from "./network.service";

@Injectable()
export class BestoranteService {

  public bestoUrl = /* "http://localhost:4200";  */ "https://bestorante.com";
  public restoUuid = /* "00000000-7a2c-130d-0000-00007a2c130d"; */ "00000000-f227-82fb-0000-0000f22782fb";
  public groups = [];
  public subGroups = [];
  public articles = [];
  public articlesByGroup = {};
  public subArticlesByGroup = {};
  public activeGroup = null;
  public restaurant = null;
  public defaultImage = null;

  networkStatusStream;
  isOnline: boolean;

  constructor(private http: HttpClient, private network: NetworkService, private utils: UtilsService, private storage: StorageService) {
    this.networkStatusStream = this.network.appIsOnline$.subscribe(online => {
      if (online) {
        this.isOnline = true;
      } else {
        this.isOnline = false;
      }
    });
  }

  public async loadRestaurant() {
    this.articles = [];
    if (this.isOnline) {
      this.http.get(this.bestoUrl + "/api/restos/" + this.restoUuid, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        headers: { Accept: "application/x-msgpack" },
        observe: "response",
        responseType: "blob"
      }).subscribe((resp) => {
        this.utils.readResponseBlob(resp, (data) => {
          this.restaurant = data;
          if (data) {
            this.storage.set("restaurant", data);
          }
          this.loadDefaultStyleData();
        });
      });
    } else {
      const restaurantFromStorage = await this.storage.get("restaurant");
      if (restaurantFromStorage) {
        this.restaurant = restaurantFromStorage;
      }
    }
  }

  public async loadGroups() {
    if (this.isOnline) {
      this.http.get(this.bestoUrl + "/api/groups/byResto?restoUuid=" + this.restoUuid, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        headers: { Accept: "application/x-msgpack" },
        observe: "response",
        responseType: "blob"
      }).subscribe( (resp) => {
        this.utils.readResponseBlob(resp, async (data) => {
          this.groups = data.filter((a) => !a.hidden && !a.internal && !a.sub && a.showInGo);
          this.subGroups = data.filter((a) => a.sub && a.showInGo);
          await this.readProducts();
          await this.readSubProducts();
          this.storage.set("groups", this.groups);
          this.storage.set("subGroups", this.subGroups);
        });
      });
    } else {
      const groupsFromStorage = await this.storage.get("groups");
      const subGroupsFromStorage = await this.storage.get("subGroups");
      if (groupsFromStorage) {
        this.groups = groupsFromStorage;
        await this.readProducts();
      }
      if (subGroupsFromStorage) {
        this.subGroups = subGroupsFromStorage;
        await this.readSubProducts();
      }
    }
  }

  public async loadDefaultStyleData() {
    if (this.isOnline) {
      this.http.get(this.bestoUrl + "/api/restos/" + this.restoUuid + "/cssConfiguration", {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        headers: { Accept: "application/json" },
        observe: "response",
        responseType: "json"
      }).subscribe( (resp) => {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (resp.body["emptyProductImageUrl"]) {
          // eslint-disable-next-line @typescript-eslint/dot-notation
          this.defaultImage = resp.body["emptyProductImageUrl"];
          this.storage.set("defaultImage", this.defaultImage);
        } else {
          this.defaultImage = null;
          this.storage.set("defaultImage", null);
        }
      });
    } else {
      const defaultImageFromStorage = await this.storage.get("defaultImage");
      if (defaultImageFromStorage) {
        this.defaultImage = defaultImageFromStorage;
      }
    }
  }

  private async readProducts() {
    if (this.isOnline) {
      for (const g of this.groups) {
        this.http.get(this.bestoUrl + "/api/articles/byGroup?restoUuid=" + this.restoUuid + "&groupUuid=" + g.uuid, {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          headers: { Accept: "application/x-msgpack" },
          observe: "response",
          responseType: "blob"
        }).subscribe((resp) => {
          this.utils.readResponseBlob(resp, (articles) => {
            if (!this.articles || this.articles.length === 0) {
              this.activeGroup = g;
              this.articles = articles;
            }
            this.articlesByGroup[g.uuid] = articles;
            this.storage.set("articlesByGroup", this.articlesByGroup);
          });
        });
      }
    } else {
      const articlesByGroupFromStorage = await this.storage.get("articlesByGroup");
      if (articlesByGroupFromStorage) {
        this.articlesByGroup = articlesByGroupFromStorage;
        this.activeGroup = this.groups[0];
        this.articles = articlesByGroupFromStorage[this.activeGroup.uuid];
      }
    }
  }

  private async readSubProducts() {
    if (this.isOnline) {
      for (const g of this.subGroups) {
        this.http.get(this.bestoUrl + "/api/articles/byGroup?restoUuid=" + this.restoUuid + "&groupUuid=" + g.uuid, {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          headers: { Accept: "application/x-msgpack" },
          observe: "response",
          responseType: "blob"
        }).subscribe((resp) => {
          this.utils.readResponseBlob(resp, (articles) => {
            if (articles) {
              articles.forEach((a) => a.groupUuid = g.uuid);
            }
            this.subArticlesByGroup[g.uuid] = articles;
            this.storage.set("subArticlesByGroup", this.subArticlesByGroup);
          });
        });
      }
    } else {
      const subArticlesByGroupFromStorage = await this.storage.get("subArticlesByGroup");
        if (subArticlesByGroupFromStorage) {
          this.subArticlesByGroup = subArticlesByGroupFromStorage;
        }
    }
  }
}
